import { render, staticRenderFns } from "./add-multi-case.vue?vue&type=template&id=3a7e0586"
import script from "./add-multi-case.vue?vue&type=script&lang=js"
export * from "./add-multi-case.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports